module.exports = __webpack_public_path__ + "img/ico-faqs.2ba2b6de.svg";